module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previosMaintain
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("Maintenance & Repair")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.allContainerDetail.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Container Details  ")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "MaingateInContainer"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Container Number")]), _vm._v(" "), _c('th', [_vm._v("Container Size")]), _vm._v(" "), _c('th', [_vm._v("Estimation Amount")]), _vm._v(" "), (_vm.maintain.status != 'Approved' && _vm.maintain.status != 'Sent_For_Approval') ? _c('th', [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allContainerDetail), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerTypeId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.materialCost == '' || item.materialCost == '0' || item.materialCost == null) ? "Survey Pending" : item.materialCost))]), _vm._v(" "), (_vm.maintain.status != 'Approved' && _vm.maintain.status != 'Sent_For_Approval') ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewEditContainerPage(item.gateInId, item.containerGateInId)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1) : _vm._e()])
  }))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gate-In No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "gateInSeries",
      "name": "gateInSeries",
      "disabled": ""
    },
    model: {
      value: (_vm.maintain.gateInSeries),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "gateInSeries", $$v)
      },
      expression: "maintain.gateInSeries"
    }
  })], 1), _vm._v(" "), (!_vm.maintain.gateInSeries) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.gateInSeriesError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Estimation Amount")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "estimationAmount",
      "name": "estimationAmount",
      "disabled": ""
    },
    model: {
      value: (_vm.maintain.estimationAmount),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "estimationAmount", $$v)
      },
      expression: "maintain.estimationAmount"
    }
  })], 1), _vm._v(" "), (!_vm.maintain.estimationAmount) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.estimationAmountError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [(_vm.maintain.maintainenceId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Approval Amount")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "approvalAmount",
      "name": "approvalAmount",
      "disabled": _vm.maintain.status == 'Approved' ? true : false
    },
    model: {
      value: (_vm.maintain.approvalAmount),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "approvalAmount", $$v)
      },
      expression: "maintain.approvalAmount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.maintain.approvalAmount) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.approvalAmountError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.maintain.maintainenceId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Approval Status")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "status",
      "id": "status",
      "disabled": _vm.maintain.status == 'Approved' ? true : false
    },
    model: {
      value: (_vm.maintain.status),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "status", $$v)
      },
      expression: "maintain.status"
    }
  }, [_c('md-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Approval Status")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "Rejected"
    }
  }, [_vm._v("Rejected")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.maintain.status) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.statusError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.maintain.maintainenceId != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Approved Date:")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Repair Date:")])], 1) : _vm._e(), _vm._v(" "), (_vm.maintain.maintainenceId != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.maintain.approvedDate),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "approvedDate", $$v)
      },
      expression: "maintain.approvedDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.maintain.repairDate),
      callback: function($$v) {
        _vm.$set(_vm.maintain, "repairDate", $$v)
      },
      expression: "maintain.repairDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addRefuelStation
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [(_vm.maintain.estimationAmount != null && _vm.maintain.maintainenceId != '' && _vm.maintain.status != 'Approved' && _vm.maintain.status != 'Sent_For_Approval') ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.mailToShippingLine
    }
  }, [_vm._v("Send For Approval")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22222",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22222
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-536ce87a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/yard/maintainRepair.vue
// module id = 2631
// module chunks = 0